import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultDisabledUsersDataSelector,
    accountSearchResultDisabledUsersResultSelector,
} from '../../slices/account-search-result-disabled-users.slice';

type Props = {
    accountId: number,
};

export const DisabledUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultDisabledUsersDataSelector);
    const result = useSelector(accountSearchResultDisabledUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/disabled"
        />
    );
};
